module.exports = __webpack_public_path__ + "static/reviewer_5-3b2aa64c16e463d78a5cb49499a290eb.png";